import {
  defineSemanticTokens,
  defineThemeContract,
  defineTokens,
} from "@pandacss/dev"

export const defineTheme = defineThemeContract({
  breakpoints: {
    desktop: "",
    largeDesktop: "",
  },
  tokens: defineTokens({
    colors: defineTokens.colors({
      error: {
        50: {value: ""},
        100: {value: ""},
        200: {value: ""},
        300: {value: ""},
        400: {value: ""},
        500: {value: ""},
        600: {value: ""},
        700: {value: ""},
        800: {value: ""},
        900: {value: ""},
        950: {value: ""},
      },
      brand: {
        50: {value: ""},
        100: {value: ""},
        200: {value: ""},
        300: {value: ""},
        400: {value: ""},
        500: {value: ""},
        600: {value: ""},
        700: {value: ""},
        800: {value: ""},
        900: {value: ""},
        950: {value: ""},
      },
      brandAccent: {
        50: {value: ""},
        100: {value: ""},
        200: {value: ""},
        300: {value: ""},
        400: {value: ""},
        500: {value: ""},
        600: {value: ""},
        700: {value: ""},
        800: {value: ""},
        900: {value: ""},
        950: {value: ""},
      },
    }),
  }),
  semanticTokens: {
    colors: defineSemanticTokens.colors({
      background: {
        primary: {value: ""},
        secondary: {value: ""},
        tertiary: {value: ""},
        quaternary: {value: ""},
        /** Near-white de-emphasized surface (e.g. non-recommended cards). */
        muted: {value: ""},
        subtle: {
          primary: {value: ""},
          brand: {value: ""},
        },
        brand: {
          primary: {value: ""},
          primarySubtle: {value: ""},
          secondary: {value: ""},
          solid: {value: ""},
          solidSubtle: {value: ""},
          accent: {value: ""},
          accentSolid: {value: ""},
          accentSolidHover: {value: ""},
          utility: {value: ""},
        },
        /** Causes / next-steps rail (may be light or dark depending on brand). */
        causesPanel: {value: ""},
        /** Per-cause row surface + hover on the causes rail. */
        causesCard: {value: ""},
        causesCardHover: {value: ""},
        error: {value: ""},
        warn: {value: ""},
        success: {value: ""},
        disabled: {value: ""},
      },
      foreground: {
        primary: {value: ""},
        primarySubtle: {value: ""},
        secondary: {value: ""},
        tertiary: {value: ""},
        quaternary: {value: ""},
        primaryOnSolid: {value: ""},
        brand: {
          primary: {value: ""},
          secondary: {value: ""},
          accent: {value: ""},
        },
        error: {
          primary: {value: ""},
        },
        warning: {
          primary: {value: ""},
        },
        secondaryOnSolid: {value: ""},
        disabled: {value: ""},
        success: {value: ""},
      },
      text: {
        brand: {
          primary: {value: ""},
          accent: {value: ""},
          secondary: {value: ""},
        },
        warning: {
          primary: {value: ""},
        },
        quaternary: {value: ""},
        tertiary: {value: ""},
        secondary: {
          DEFAULT: {value: ""},
          onSolid: {value: ""},
        },
        error: {
          primary: {value: ""},
        },
        primary: {
          DEFAULT: {value: ""},
          subtle: {value: ""},
          onSolid: {value: ""},
        },
        /** Text links: default + hover (Bodewell #245B83 / #3E5769). */
        link: {
          DEFAULT: {value: ""},
          hover: {value: ""},
        },
        causesPanel: {
          primary: {value: ""},
          muted: {value: ""},
          /** Decorative background-pattern SVG ink (via currentColor). */
          pattern: {value: ""},
        },
        disabled: {value: ""},
        success: {value: ""},
      },
      border: {
        brand: {
          primary: {value: ""},
          primarySolid: {value: ""},
          secondarySolid: {value: ""},
          secondary: {value: ""},
          accent: {value: ""},
          accentHover: {value: ""},
        },
        secondary: {
          solid: {value: ""},
          200: {value: ""},
        },
        primary: {
          300: {value: ""},
          solid: {
            700: {value: ""},
          },
        },
        onWarning: {value: ""},
        error: {value: ""},
        disabled: {value: ""},
        successSubtle: {value: ""},
        errorSubtle: {value: ""},
        causeCard: {value: ""},
      },
      confirmedIconsBackground: {
        100: {value: ""},
        200: {value: ""},
        300: {value: ""},
        400: {value: ""},
        500: {value: ""},
        600: {value: ""},
        700: {value: ""},
        800: {value: ""},
        900: {value: ""},
      },
    }),
    gradients: {
      causesHoverGradient: {value: ""},
      causesHoverBorderGradient: {value: ""},
      conversationFade: {value: ""},
      /** Mask applied over the causes-rail decorative pattern; opaque
       * everywhere = pattern shows at full strength (no fade). */
      causesPatternMask: {value: ""},
      /** AI/tag accent text-gradient — "positive" tone (confirmed causes, primary tag). */
      aiAccentPrimary: {value: ""},
      /** AI/tag accent text-gradient — "attention" tone (denied/likely causes, danger tag). */
      aiAccentDanger: {value: ""},
    },
    radii: {
      /** Per-cause row card radius on the causes rail (0 = flat divider list). */
      causeCard: {value: ""},
    },
    borderWidths: {
      /** Left/right/bottom width for cause row cards (0 = top divider only). */
      causeCardSide: {value: ""},
    },
    spacing: {
      /** Gap between cause rows when they render as separated cards. */
      causesCardGap: {value: ""},
    },
  },
  textStyles: {},
  keyframes: {},
})
